export default __webpack_public_path__ + "static/media/build-from-scratch.76ac230b.svg";